// extracted by mini-css-extract-plugin
module.exports = {"quoteText":"Highlight_quoteText__HGzXR","titleWrapper":"Highlight_titleWrapper__UKaMa","title":"Highlight_title__S_TeR","quoteBody":"Highlight_quoteBody__FK0Ce"};